export const TEAMS_SUPPORT_CHANNEL_URL =
  "https://teams.microsoft.com/l/channel/19%3AAY2rQKV1bnWs9BJa0G7IJeHNz45RAxOSdFGih8P0nEU1%40thread.tacv2/Support-%20Vylor%20Research%20Chat?groupId=da408d6d-dc17-4de2-bbcd-2f027f1a154f&tenantId=db505480-8ec6-495c-b579-32c58ed84a01";
